import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { isUser } from '../ducks/auth';
import { uiActionCreators } from '../ducks/ui';
import { useMiaSelector } from './hooks';
import { JsonTree } from './JsonTree';

interface IMessageDialogProps {}

let MessageDialog: React.FunctionComponent<IMessageDialogProps> = () => {
  const dispatch = useDispatch();
  const isItUser = useMiaSelector(state => isUser(state, 'it'));
  const messageDialog = useMiaSelector(state => state.ui.messageDialog);

  const exceptionStyle = React.useMemo<React.CSSProperties>(() => ({ maxHeight: 500, overflowY: 'auto' }), []);
  const [showException, setShowException] = React.useState<boolean>(isItUser);

  const handleShowExceptionClick = React.useCallback(() => {
    setShowException(current => !current);
  }, []);

  const handleClose = React.useCallback(() => {
    dispatch(uiActionCreators.hideMessageDialog());
  }, []);

  return (
    <>
      {messageDialog && (
        <Dialog open onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>{messageDialog.title}</DialogTitle>
          <DialogContent>
            <ul>
              <DialogContentText>
                {messageDialog.messages.map((x, idx) => (
                  <li key={idx}>{x}</li>
                ))}
              </DialogContentText>
            </ul>

            {messageDialog.exception && (
              <>
                <Button onClick={handleShowExceptionClick}>{showException ? 'Hide' : 'Show'} Exception</Button>
                <Collapse in={showException}>
                  <div style={exceptionStyle}>
                    <JsonTree data={messageDialog.exception} />
                  </div>
                </Collapse>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

MessageDialog = React.memo<IMessageDialogProps>(MessageDialog);
export { MessageDialog };
